import * as React from 'react';
import * as cn from 'classnames';
import * as styles from './styles.css';

export interface IButtonProps {
  children: React.ReactNode;
  isActive?: boolean;
  onClick?(): void;
}

export function Button({ children, onClick, isActive }: IButtonProps) {
  return (
    <button type="button" onClick={onClick} className={cn(styles['button'], isActive && styles['active'])}>
      {children}
    </button>
  );
}
